// extracted by mini-css-extract-plugin
module.exports = {"form":"ActivationExpiredForm_form__-zvte","submitButton":"ActivationExpiredForm_submitButton__2m0sj","centered":"ActivationExpiredForm_centered__3anmE"};